import type { EventTags } from '@optimizely/optimizely-sdk'

import { OptimizelyState } from '@/context/optimizely-decisions-context'
import { trackClientSideOptimizelyEvent } from '@/utils/optimizely/trackOptimizelyEvent'

import type { ExplorationLocation, ExplorationTile } from './data'

export type ExplorationInteraction = 'click' | 'impression'

// Regex-free on purpose (avoids the SonarCloud ReDoS hotspot, S7764/S5852).
const toSnakeCase = (value: string): string => {
  const lower = value.trim().toLowerCase()
  const parts: string[] = []
  let current = ''

  for (const char of lower) {
    const isAlphaNumeric =
      (char >= 'a' && char <= 'z') || (char >= '0' && char <= '9')

    if (isAlphaNumeric) {
      current += char
    } else if (current !== '') {
      parts.push(current)
      current = ''
    }
  }

  if (current !== '') {
    parts.push(current)
  }

  return parts.join('_')
}

export const buildExplorationEventKey = (
  location: ExplorationLocation,
  tile: ExplorationTile,
  position: number,
): string =>
  `exploration_suggestions_widget_${location}_${toSnakeCase(tile.name)}_${position}`

export const trackExplorationInteraction = (
  location: ExplorationLocation,
  tile: ExplorationTile,
  position: number,
  interaction: ExplorationInteraction,
  optimizelyState: OptimizelyState,
): Promise<void> => {
  const eventTags: EventTags = { interaction }

  return trackClientSideOptimizelyEvent(
    buildExplorationEventKey(location, tile, position),
    optimizelyState,
    eventTags,
  )
}
